import { cn } from '@optools/components/ui/utils';
import { CalendarX2 } from 'lucide-react';

export interface NoGamesTodayProps {
  className?: string;
}

export function NoGamesToday({ className }: NoGamesTodayProps) {
  return (
    <div
      className={cn(
        'flex h-full flex-col items-center justify-center gap-4 border border-dashed',
        className,
      )}>
      <CalendarX2 className="size-20 stroke-1" />
      <h2 className="text-lg">No Games Today</h2>
    </div>
  );
}
